import React from "react";
import toast from "react-hot-toast";
import { Oval } from "react-loader-spinner";
import { BsLockFill, BsUnlockFill } from "react-icons/bs";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { setScheduleDayLock } from "../../scheduleSlice";
import "./LockDayToggle.scss";

interface Props {
  date: string; // YYYY-MM-DD
}

export function LockDayToggle({ date }: Props) {
  const dispatch = useAppDispatch();
  const scheduleDay = useAppSelector((state) => state.schedules.scheduleDay);
  const loading = useAppSelector(
    (state) => state.schedules.setScheduleDayLockAPI.loading
  );

  const isLocked = scheduleDay?.isLocked ?? false;

  const onToggle = () => {
    dispatch(setScheduleDayLock({ date, locked: !isLocked }))
      .unwrap()
      .catch(() => toast.error("Couldn't update the day lock. Please try again."));
  };

  return (
    <button
      type="button"
      className={`lock-day-toggle ${isLocked ? "lock-day-toggle--locked" : "lock-day-toggle--open"}`}
      onClick={onToggle}
      disabled={loading}
      title={
        isLocked
          ? "Locked to the automation — click to unlock"
          : "Open to the automation — click to lock"
      }
    >
      {loading ? (
        <Oval height={16} width={16} color="#fff" secondaryColor="#ccc" strokeWidth={4} />
      ) : isLocked ? (
        <BsLockFill />
      ) : (
        <BsUnlockFill />
      )}
      <span>{isLocked ? "Locked" : "Open"}</span>
    </button>
  );
}
